import { publicRequest, request } from '@/utils/request';

// 我的答题卡
export function myAnswerSheet(params){ 
  return request({
    url: '/teachingCenter/onlineCourse/myAnswerSheet',
    method:"get",
    params
  })
}

// 交卷
export function submitOnlineCourse(data){ 
  return request({
    url: '/teachingCenter/onlineCourse/submit',
    method:"post",
    data
  })
}

// 用户答题详情
export function courseAnswerSheetDetail(params){ 
  return request({
    url: '/teachingCenter/onlineCourse/courseAnswerSheetDetail',
    method:"get",
    params
  })
}

// 答题卡结果集
export function myAnswerSheetls(params){ 
  return request({
    url: '/teachingCenter/teachingPlanPaperRecord/myAnswerSheet',
    method:"get",
    params
  })
}

// 交卷
export function submitTeachingPlanPaperRecord(data){ 
  return request({
    url: '/teachingCenter/teachingPlanPaperRecord/submit',
    method:"post",
    data
  })
}

// 用户答题详情
export function planUserAnswerSheetDetail(params){ 
  return request({
    url: '/teachingCenter/teachingPlanPaperRecord/planUserAnswerSheetDetail',
    method:"get",
    params
  })
}